import { render, staticRenderFns } from "./FullServicePostsWidgets.vue?vue&type=template&id=7a0c240d&scoped=true&"
import script from "./FullServicePostsWidgets.vue?vue&type=script&lang=js&"
export * from "./FullServicePostsWidgets.vue?vue&type=script&lang=js&"
import style0 from "./FullServicePostsWidgets.vue?vue&type=style&index=0&id=7a0c240d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0c240d",
  null
  
)

export default component.exports